import {
  IonButton,
  IonItem,
  IonList,
  IonPopover,
  IonRadio,
  IonRadioGroup,
  IonRefresher,
  IonRefresherContent,
  IonSkeletonText,
  useIonToast,
  IonModal,
  IonHeader,
  IonToolbar,
  IonTitle,
  IonButtons,
  IonIcon,
  IonContent, IonAccordionGroup, IonAccordion, IonFooter, IonLabel, IonSearchbar, IonInput, IonGrid, IonCol, IonRow
} from "@ionic/react";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { CardComponent } from "../components/Cards/StoreCard";
import useInterval from "use-interval";
import MyPortal from "../components/MyPortal";
import dayjs from "dayjs";
import SortFunctions from "../components/SortFunctions";
import { analyticFrequencyInMS, sendAnalytics } from "../components/functions";
import { useSelector } from "react-redux";
import { useMediaQuery } from "react-responsive";
import { 
  funnel as funnelOutline, 
  close as closeOutline, 
  funnelSharp, 
  search as searchOutline, 
  arrowBack as arrowBackOutline 
} from 'ionicons/icons';
import { useHistory } from "react-router-dom";

const fields = [
  { label: "TS", dataIndex: "today_amt" },
  { label: "YS", dataIndex: "yesterday_amt" },
  { label: "WTD", dataIndex: "this_week_amt" },
  { label: "MTD", dataIndex: "this_month_amt" },
  { label: "", dataIndex: "ts_last_year_amt" },
  { label: "", dataIndex: "ys_last_year_amt" },
  { label: "", dataIndex: "ws_last_year_amt" },
  { label: "", dataIndex: "ms_last_year_amt" },
  { label: "TSGR%", dataIndex: "today_growth_pct" },
  { label: "YSGR%", dataIndex: "yesterday_growth_pct" },
  { label: "WTDGR%", dataIndex: "week_growth_pct" },
  { label: "MTDGR%", dataIndex: "month_growth_pct" },
];

export default function SUData() {
  const history = useHistory();
  const suBase = history.location.pathname.startsWith("/legacy/") ? "/legacy" : "";
  const authReducer = useSelector((state) => state.authReducer);
  const [details, setDetails] = React.useState([]);
  const [stores, setStores] = useState([]);
  const [loading, setLoading] = React.useState(true);
  const [present] = useIonToast();
  const [viewMode, setViewMode] = React.useState('state'); // 'state' or 'store'
  const [selectedRegion, setSelectedRegion] = React.useState(null);

  // Updated sort state structure
  const [sortState, setSortState] = React.useState({ key: null, direction: null });
  const { handleAscSort, handleDesSort } = SortFunctions({ details, setSortState, setDetails });

  const [masterStoreTypes, setMasterStoreTypes] = React.useState([]);
  const [masterRegionCodes, setMasterRegionCodes] = React.useState([]);
  const [storeTypeFilter, setStoreTypeFilter] = React.useState('ALL'); // Default ALL for state/region view
  const [regionCodeFilter, setRegionCodeFilter] = React.useState(null);

  const [isSortPopoverOpen, setIsSortPopoverOpen] = React.useState(false);
  const [isStoreTypePopoverOpen, setIsStoreTypePopoverOpen] = React.useState(false);
  const [isRegionPopoverOpen, setIsRegionPopoverOpen] = React.useState(false);

  const isMobile = useMediaQuery({ maxWidth: 768 });
  const [isMobileFilterDrawerOpen, setIsMobileFilterDrawerOpen] = React.useState(false);

  const filtersApplied = storeTypeFilter !== null || regionCodeFilter !== null || sortState.key !== null;
  const [selectedSortOption, setSelectedSortOption] = useState(null);
  const [searchText, setSearchText] = useState("");
  const [isSearchModalOpen, setIsSearchModalOpen] = useState(false);

  // Store search API state
  const [storeResults, setStoreResults] = useState([]);
  const [storeLoading, setStoreLoading] = useState(false);

  function handleDSort() {
    window.location.reload(true);
  }

  const getData = async (refreshEvent) => {
    setLoading(true);
    try {
      const params = {
        summary: viewMode,
        // Send the selected store type filter (which initially defaults to 'LTL'). If ALL is selected (null), don't send store_type.
        store_type: storeTypeFilter || undefined,
        region: selectedRegion || regionCodeFilter || undefined
      };

      const res = await axios.get("/style_union/get_sales_data", { params });
      console.log("Sales Data Response:", res.data);
      
      const formatToLakh = (value) => (value / 100000).toFixed(2);

      const mapped = res.data.data.map((item) => ({
        ...item,
        today_amt_number: item.today_amt || 0,
        yesterday_amt_number: item.yesterday_amt || 0,
        this_week_amt_number: item.this_week_amt || 0,
        this_month_amt_number: item.this_month_amt || 0,
        today_amt: item.today_amt,
        yesterday_amt: item.yesterday_amt,
        this_week_amt: item.this_week_amt,
        this_month_amt: item.this_month_amt,
        store_count: item.store_count ?? item.total_stores ?? item.count ?? 0,
        ts_last_year_amt: `${formatToLakh(item.ts_last_year_amt || 0)} `,
        ys_last_year_amt: `${formatToLakh(item.ys_last_year_amt || 0)} `,
        ws_last_year_amt: `${formatToLakh(item.ws_last_year_amt || 0)} `,
        ms_last_year_amt: `${formatToLakh(item.ms_last_year_amt || 0)} `,
        wtd_gr_percent: item.week_growth_pct || 0,
        mtd_gr_percent: item.month_growth_pct || 0,
      }));

      let finalDetails = mapped;

      if (sortState.key && sortState.direction) {
        finalDetails = [...finalDetails].sort((a, b) => {
          const aVal = a[sortState.key] ?? 0;
          const bVal = b[sortState.key] ?? 0;
          return sortState.direction === "asc" ? aVal - bVal : bVal - aVal;
        });
      }

      const filteredDetails = finalDetails.filter((item) =>
                item.store_name?.toLowerCase().includes((searchText || "").toLowerCase())
              );

      setDetails([finalDetails?.find((item) => item?.store_name === "Style Union"), ...filteredDetails?.filter((item) => item?.store_name !== "Style Union")]);

      if (masterStoreTypes.length === 0 && masterRegionCodes.length === 0) {
        const allStoreTypes = [...new Set(res.data.data.map((item) => item.store_type))].filter(Boolean);
        const allRegionCodes = [...new Set(res.data.data.map((item) => item.region_code))].filter(Boolean);
        setMasterStoreTypes(allStoreTypes);
        setMasterRegionCodes(allRegionCodes);
      }
    } catch (err) {
      console.error("Error fetching sales data:", err);
      await present({
        message: err?.response?.data?.message || "Error Occurred",
        duration: 2000,
        color: "danger",
      });
    }
    setLoading(false);
    if (refreshEvent && refreshEvent.detail && typeof refreshEvent.detail.complete === "function") {
      refreshEvent.detail.complete();
    }
  };

  // Fetch all stores for search (independent of main details)
  useEffect(() => {
    async function fetchStores() {
      setStoreLoading(true);
      try {
        const res = await axios.get("/style_union/get_sales_data", { params: { summary: "store" } });
        setStoreResults(res.data.data || []);
        
      } catch (err) {
        setStoreResults([]);
      }
      setStoreLoading(false);
    }
    fetchStores();
  }, []);

  useEffect(() => {
    if (searchText) {
      console.log(filteredStores);
      setDetails( filteredStores?.filter((item) => console.log()));
    } else {
      getData();
    }
  }, [searchText, storeTypeFilter, regionCodeFilter, viewMode, selectedRegion]);


  useInterval(() => {
    if (document.visibilityState === "visible") {
      sendAnalytics("1", authReducer.user.userId, authReducer.user.username);
    }
  }, analyticFrequencyInMS);

  useEffect(() => {
    sendAnalytics("1", authReducer.user.userId, authReducer.user.username);
  }, []);

  // Filter storeResults by searchText
  
  const filteredStores = storeResults.filter(
    (item) => item.store_name?.toLowerCase().includes(searchText.toLowerCase())
  );


  return (
    <div
      style={{
        display: "inline-flex",
        justifyContent: "space-around",
        width: "100%",
        flexWrap: "wrap",
        position: "relative",
        paddingBottom: "50px",
      }}
    >
      <IonRefresher slot="fixed" onIonRefresh={getData}>
        <IonRefresherContent></IonRefresherContent>
      </IonRefresher>

      {loading && !details?.length &&
        Array.from({ length: 10 }).map((_, i) => (
          <IonSkeletonText
            key={i}
            animated
            style={{height: "150px" }}
          />
        ))}

      {/* TOPBAR */}
      <MyPortal id="navbar-portal-div">
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            width: "100%",
            // padding: "0 1rem",
          }}
        >
          {/* Left: Title */}
        <div style={{ flex: '1 1 auto', minWidth: 0 }}>
            <div style={{ 
              fontWeight: isMobile ? 200 : 500, 
               fontSize: isMobile ? "0.9rem" : "1.5rem",
              display: "grid", 
              textAlign: 'left',
               overflow: 'hidden',
                textOverflow: 'ellipsis',
                 whiteSpace: 'nowrap',
                 marginRight: isMobile ? "0.1rem" : "0" ,
                 }}>
              Style Union
              <span style={{ fontSize: "0.8rem", marginTop: "0.2rem" }}>
                {details?.[1]?.updated_at && dayjs(details?.[1]?.updated_at).fromNow()}
              </span>
            </div>
        </div>
        

          {/* Right: Buttons */}
          <div>
            {isMobile ? (
              <div style={{ 
                 display: "flex",
              justifyContent: "flex-end", // pushes content to the right
              alignItems: "center",
              width: "100%",
                }}>
                {/* Mobile quick store-type buttons (only on region/state view) */}
                {viewMode === 'state' && (
                  <div style={{ display: 'flex', gap: '6px', alignItems: 'center', marginRight: '6px' }}>
                    <IonButton
                      size="small"
                      fill={storeTypeFilter === 'LTL' ? 'solid' : 'outline'}
                      onClick={() => setStoreTypeFilter(storeTypeFilter === 'LTL' ? null : 'LTL')}
                    >
                      LTL
                    </IonButton>
                    <IonButton
                      size="small"
                      fill={storeTypeFilter === 'PTL' ? 'solid' : 'outline'}
                      onClick={() => setStoreTypeFilter(storeTypeFilter === 'PTL' ? null : 'PTL')}
                    >
                      PTL
                    </IonButton>
                  </div>
                )}
                {viewMode === 'store' || viewMode === 'state' && (
                  <div>
                    <IonButton
                      style={{ marginLeft: "0.0rem", marginRight: "0.0rem", width: "100%" }}
                      fill="clear"
                      size="small"
                      onClick={() => setIsSearchModalOpen(true)}
                    >
                      <IonIcon icon={searchOutline} />
                    </IonButton>
                  </div>
                )}
                <div>
                  <IonButton
                    style={{ marginLeft: "0.0rem", marginRight: "0.0rem", width: "100%" }}
                    fill="clear"
                    size="small"
                    onClick={() => setIsMobileFilterDrawerOpen(true)}
                  >
                    <IonIcon icon={filtersApplied ? funnelSharp : funnelOutline} />
                  </IonButton>
                </div>
              </div>
            ) : (
              <div style={{display: "inline-flex"}}>
                {(
                  <div style={{
                    height: '20px',
                    marginRight: '10px'
                  }}>
                    <IonSearchbar
                      value={searchText}
                      onIonInput={(e) => {
                        const value = e.target.value;
                        setSearchText(value);
                      }}
                      placeholder="Search Store..."
                      debounce={300}
                    /> 
                  </div>
                )}
                 {/* Store Type Filter Buttons – only shown on region (state) view */}
          <div>
          {!isMobile && viewMode === 'state' ? (
            <div style={{ display: "flex", gap: "0.5rem" }}>
              <IonButton
                color="primary"
                fill={storeTypeFilter === 'LTL' ? 'solid' : 'outline'}
                onClick={() => setStoreTypeFilter('LTL')}
              >
                LTL
              </IonButton>
              <IonButton
                color="primary"
                fill={storeTypeFilter === 'PTL' ? 'solid' : 'outline'}
                onClick={() => setStoreTypeFilter('PTL')}
              >
                PTL
              </IonButton>
              <IonButton
                color="primary"
                fill={storeTypeFilter === 'NEW_STORE' ? 'solid' : 'outline'}
                onClick={() => setStoreTypeFilter('NEW_STORE')}
              >
                NEW_STORE
              </IonButton>
            </div>
          ) : null}
          </div>
                  
                <div>
                  <IonButton
                    size="default"
                    color="white"
                    id="popover-su-button"
                    onClick={() => setIsSortPopoverOpen(!isSortPopoverOpen)}
                  >
                    Sort By
                  </IonButton>
                  {viewMode === 'store' && (
                    <>
                      <IonButton
                        size="default"
                        color="white"
                        id="popover-storetype-button"
                        onClick={() => setIsStoreTypePopoverOpen(!isStoreTypePopoverOpen)}
                      >
                        STORE TYPE: {storeTypeFilter ?? "All"}
                      </IonButton>
                      {!selectedRegion && (
                        <IonButton
                          size="default"
                          color="white"
                          id="popover-region-button"
                          onClick={() => setIsRegionPopoverOpen(!isRegionPopoverOpen)}
                        >
                          REGION: {regionCodeFilter ?? "All"}
                        </IonButton>
                      )}
                    </>
                  )}
                </div>

              </div>
            )}
          </div>
        </div>
      </MyPortal>

        {/* Cards */}
        <div className="cards-container" style={{
          display: "flex",
          flexWrap: "wrap",
          gap: isMobile ? "0.5rem" : "1rem",
          padding: isMobile ? "0.5rem" : "1rem",
          width: "100%",
          justifyContent: "center"
        }}>
          {details.map((item, index) => (
            <div 
              key={index}
              onClick={viewMode === 'state' ? () => {
                const query = storeTypeFilter ? `?storeType=${storeTypeFilter}` : '';
                if (item.store_name === 'Style Union') {
                  setViewMode('store');
                  history.push(`${suBase}/sales/styleunion/region/All STORES${query}`);
                }else{
                  const region = item.store_name !== 'Style Union' ? encodeURIComponent(item.store_name) : undefined;
                  history.push(`${suBase}/sales/styleunion/region/${region}${query}`);
                }
              } : undefined}
              style={{
                cursor: viewMode === 'state' ? 'pointer' : 'default',
                flexBasis: isMobile ? "100%" : "calc(50% - 1rem)",
                maxWidth: isMobile ? "100%" : "400px",
                minWidth: isMobile ? "auto" : "300px"
              }}
            >
              <CardComponent 
                data={item} 
                fields={fields} 
                fieldsInOneRow={4}
                showStoreCountPrefix={false}
                showStoreCountRight={viewMode === 'state'}
              />
              <IonButton
                expand="block"
                style={{
                        width: "91%",
                        alignSelf: "center",
                        marginRight : "0.5rem",
                        marginLeft: "0.5rem",
                        height: "42px",
                        "--background": "linear-gradient(135deg, #4b4b4b, #2c2c2c)", // dark gray gradient
                        "--color": "#ffffff", // white text
                        "--border-radius": "12px",
                        fontWeight: "600",
                        letterSpacing: "0.6px",
                        textTransform: "uppercase",
                        boxShadow: "0 4px 12px rgba(0, 0, 0, 0.5)", // subtle dark shadow
                        transition: "transform 0.2s, box-shadow 0.2s",

                }}
                onClick={() => {
                  present();
                }}
              >
                View Store
              </IonButton>
            </div>
          ))}
        </div>

      {/* Store Search Results */}
      {searchText && (
        <div className="cards-container" style={{
          display: "flex",
          flexWrap: "wrap",
          gap: isMobile ? "0.5rem" : "1rem",
          padding: isMobile ? "0.5rem" : "1rem",
          width: "100%",
          justifyContent: "center"
        }}>
          {filteredStores.filter(item => item.store_name !== "Style Union").map((item, index) => (
            
            <div key={index} style={{ maxWidth: "400px", minWidth: "300px" }}>
              {/* {console.log("Filtered Store Item:", item)} */}
              <CardComponent data={item} fields={fields} fieldsInOneRow={4} />
            </div>
          ))}
          {!storeLoading && filteredStores.filter(item => item.store_name !== "Style Union").length === 0 && (
            <div style={{ textAlign: "center", width: "100%", marginTop: "2rem" }}>
              No stores found.
            </div>
          )}
        </div>
      )}

      {/* Popovers (Desktop) */}
      <IonPopover
  isOpen={isSortPopoverOpen}
  trigger="popover-su-button"
  keepContentsMounted
  dismissOnSelect={false} 
  side="bottom"
  size="auto"
  className="wide-popover"
>
  <IonContent className="ion-padding">
    <IonAccordionGroup expand="first">
      {/* Default */}
      <IonItem
        button
        onClick={() => {
          setSelectedSortOption("default");
          handleDSort("default");
        }}
      >
        <IonLabel><b>Default</b></IonLabel>
      </IonItem>

      {/* TS */}
      <IonAccordion value="ts">
        <IonItem slot="header">
          <IonLabel>TS</IonLabel>
        </IonItem>
        <div className="ion-padding" slot="content">
          <IonRadioGroup
            value={selectedSortOption}
            onIonChange={(e) => {
              const value = e.detail.value;
              setSelectedSortOption(value);
              if (value === "ts_asc") handleAscSort("today_amt");
              else if (value === "ts_desc") handleDesSort("today_amt");

              setIsSortPopoverOpen(false);
            }}
          >
            <IonItem>
              <IonLabel>Low to High</IonLabel>
              <IonRadio slot="end" value="ts_asc" />
            </IonItem>
            <IonItem>
              <IonLabel>High to Low</IonLabel>
              <IonRadio slot="end" value="ts_desc" />
            </IonItem>
          </IonRadioGroup>
        </div>
      </IonAccordion>

      {/* YS */}
      <IonAccordion value="ys">
        <IonItem slot="header">
          <IonLabel>YS</IonLabel>
        </IonItem>
        <div className="ion-padding" slot="content">
          <IonRadioGroup
            value={selectedSortOption}
            onIonChange={(e) => {
              const value = e.detail.value;
              setSelectedSortOption(value);
              if (value === "ys_asc") handleAscSort("yesterday_amt");
              else if (value === "ys_desc") handleDesSort("yesterday_amt");

              setIsSortPopoverOpen(false);
            }}
          >
            <IonItem>
              <IonLabel>Low to High</IonLabel>
              <IonRadio slot="end" value="ys_asc" />
            </IonItem>
            <IonItem>
              <IonLabel>High to Low</IonLabel>
              <IonRadio slot="end" value="ys_desc" />
            </IonItem>
          </IonRadioGroup>
        </div>
      </IonAccordion>

      {/* WTDS */}
      <IonAccordion value="wtds">
        <IonItem slot="header">
          <IonLabel>WTDS</IonLabel>
        </IonItem>
        <div className="ion-padding" slot="content">
          <IonRadioGroup
            value={selectedSortOption}
            onIonChange={(e) => {
              const value = e.detail.value;
              setSelectedSortOption(value);
              if (value === "wtds_asc") handleAscSort("this_week_amt");
              else if (value === "wtds_desc") handleDesSort("this_week_amt");

              setIsSortPopoverOpen(false);
            }}
          >
            <IonItem>
              <IonLabel>Low to High</IonLabel>
              <IonRadio slot="end" value="wtds_asc" />
            </IonItem>
            <IonItem>
              <IonLabel>High to Low</IonLabel>
              <IonRadio slot="end" value="wtds_desc" />
            </IonItem>
          </IonRadioGroup>
        </div>
      </IonAccordion>

      {/* MTDS */}
      <IonAccordion value="mtds">
        <IonItem slot="header">
          <IonLabel>MTDS</IonLabel>
        </IonItem>
        <div className="ion-padding" slot="content">
          <IonRadioGroup
            value={selectedSortOption}
            onIonChange={(e) => {
              const value = e.detail.value;
              setSelectedSortOption(value);
              if (value === "mtds_asc") handleAscSort("this_month_amt");
              else if (value === "mtds_desc") handleDesSort("this_month_amt");

              setIsSortPopoverOpen(false);
            }}
          >
            <IonItem>
              <IonLabel>Low to High</IonLabel>
              <IonRadio slot="end" value="mtds_asc" />
            </IonItem>
            <IonItem>
              <IonLabel>High to Low</IonLabel>
              <IonRadio slot="end" value="mtds_desc" />
            </IonItem>
          </IonRadioGroup>
        </div>
      </IonAccordion>

      {/* WTD Growth */}
      <IonAccordion value="wtd_growth">
        <IonItem slot="header">
          <IonLabel>WTD Growth</IonLabel>
        </IonItem>
        <div className="ion-padding" slot="content">
          <IonRadioGroup
            value={selectedSortOption}
            onIonChange={(e) => {
              const value = e.detail.value;
              setSelectedSortOption(value);
              if (value === "wtdsgr_asc") handleAscSort("wtd_gr_percent");
              else if (value === "wtdsgr_desc") handleDesSort("wtd_gr_percent");

              setIsSortPopoverOpen(false);
            }}
          >
            <IonItem>
              <IonLabel>Low to High</IonLabel>
              <IonRadio slot="end" value="wtdsgr_asc" />
            </IonItem>
            <IonItem>
              <IonLabel>High to Low</IonLabel>
              <IonRadio slot="end" value="wtdsgr_desc" />
            </IonItem>
          </IonRadioGroup>
        </div>
      </IonAccordion>

      {/* MTD Growth */}
      <IonAccordion value="mtd_growth">
        <IonItem slot="header">
          <IonLabel>MTD Growth</IonLabel>
        </IonItem>
        <div className="ion-padding" slot="content">
          <IonRadioGroup
            value={selectedSortOption}
            onIonChange={(e) => {
              const value = e.detail.value;
              setSelectedSortOption(value);
              if (value === "mtdsgr_asc") handleAscSort("mtd_gr_percent");
              else if (value === "mtdsgr_desc") handleDesSort("mtd_gr_percent");

              setIsSortPopoverOpen(false);
            }}
          >
            <IonItem>
              <IonLabel>Low to High</IonLabel>
              <IonRadio slot="end" value="mtdsgr_asc" />
            </IonItem>
            <IonItem>
              <IonLabel>High to Low</IonLabel>
              <IonRadio slot="end" value="mtdsgr_desc" />
            </IonItem>
          </IonRadioGroup>
        </div>
      </IonAccordion>
    </IonAccordionGroup>
  </IonContent>
</IonPopover>


      <IonPopover isOpen={isStoreTypePopoverOpen} trigger="popover-storetype-button" keepContentsMounted dismissOnSelect side="bottom" size="auto">
        <IonList>
          <IonRadioGroup value={storeTypeFilter ?? "all"} onIonChange={(e) => setStoreTypeFilter(e.detail.value === "all" ? null : e.detail.value)}>
            <IonItem>All Store Types<IonRadio slot="end" value="all" /></IonItem>
            {masterStoreTypes.map((type) => (
              <IonItem key={type}>{type}<IonRadio slot="end" value={type} /></IonItem>
            ))}
          </IonRadioGroup>
        </IonList>
      </IonPopover>

      <IonPopover isOpen={isRegionPopoverOpen} trigger="popover-region-button" keepContentsMounted dismissOnSelect side="bottom" size="auto">
        <IonList>
          <IonRadioGroup value={regionCodeFilter ?? "all"} onIonChange={(e) => setRegionCodeFilter(e.detail.value === "all" ? null : e.detail.value)}>
            <IonItem>All Regions<IonRadio slot="end" value="all" /></IonItem>
            {masterRegionCodes.map((code) => (
              <IonItem key={code}>{code}<IonRadio slot="end" value={code} /></IonItem>
            ))}
          </IonRadioGroup>
        </IonList>
      </IonPopover>

      {/* Mobile Filter Drawer */}
      <IonModal
        isOpen={isMobileFilterDrawerOpen}
        onDidDismiss={() => setIsMobileFilterDrawerOpen(false)}
        className="mobile-filter-modal"
      >
        <IonHeader>
          <IonToolbar>
            <IonTitle>Filters</IonTitle>
            {/* close icon removed from header; use footer Apply/Clear to close */}
          </IonToolbar>
        </IonHeader>

        <IonContent className="ion-padding">
          {/* {(
            <div className="search-section" style={{ marginBottom: '16px' }}>
              <IonItem>
                <IonIcon icon={searchOutline} slot="start" />
                <IonInput
                  type="text"
                  value={searchText}
                  placeholder="Search Region name..."
                  onIonInput={(e) => setSearchText(e.detail.value)}
                  clearInput
                />
              </IonItem>
            </div>
          )} */}
          <IonAccordionGroup expand="first">
            {/* Store Type filter – shown in state (region) view */}
            {viewMode === 'state' && (
              <IonAccordion value="storetype-state">
                <IonItem slot="header"><b>Store Type</b></IonItem>
                <div className="ion-padding" slot="content">
                  <IonRadioGroup
                    value={storeTypeFilter ?? "all"}
                    onIonChange={(e) => setStoreTypeFilter(e.detail.value === "all" ? null : e.detail.value)}
                  >
                    <IonItem>
                      <IonLabel>All</IonLabel>
                      <IonRadio slot="end" value="all" />
                    </IonItem>
                    <IonItem>
                      <IonLabel>NEW_STORE</IonLabel>
                      <IonRadio slot="end" value="NEW_STORE" />
                    </IonItem>
                  </IonRadioGroup>
                </div>
              </IonAccordion>
            )}

            {/* Sort By Accordion */}
            <IonAccordion value="sort">
              <IonItem slot="header"><b>Sort By</b></IonItem>
              <div className="ion-padding" slot="content">
                <IonRadioGroup>
                  <IonAccordionGroup expand="inset">
                    {/* Default Sort */}
                    <IonItem button onClick={() => handleDSort("default")}>
                      Default
                    </IonItem>

                    {/* TS Sort */}
                    <IonAccordion value="ts">
                      <IonItem slot="header">
                        <IonLabel>TS</IonLabel>
                      </IonItem>

                      <div className="ion-padding" slot="content">
                        <IonRadioGroup
                          value={selectedSortOption}
                          onIonChange={(e) => {
                            const value = e.detail.value;
                            console.log("value", value,e);
                            
                            setSelectedSortOption(value);

                            if (value === "ts_asc") {
                              handleAscSort("today_amt");
                            } else if (value === "ts_desc") {
                              handleDesSort("today_amt");
                            }
                          }}
                        >
                          <IonItem>
                            <IonLabel>Low to High</IonLabel>
                            <IonRadio slot="end" value="ts_asc" />
                          </IonItem>
                          <IonItem>
                            <IonLabel>High to Low</IonLabel>
                            <IonRadio slot="end" value="ts_desc" />
                          </IonItem>
                        </IonRadioGroup>
                      </div>
                    </IonAccordion>

                    {/* YS Sort */}
                    <IonAccordion value="ys">
                      <IonItem slot="header">
                        <IonLabel>YS</IonLabel>
                      </IonItem>

                      <div className="ion-padding" slot="content">
                        <IonRadioGroup
                          value={selectedSortOption}
                          onIonChange={(e) => {
                            const value = e.detail.value;
                            setSelectedSortOption(value);

                            if (value === "ys_asc") {
                              handleAscSort("yesterday_amt");
                            } else if (value === "ys_desc") {
                              handleDesSort("yesterday_amt");
                            }
                          }}
                        >
                          <IonItem>
                            <IonLabel>Low to High</IonLabel>
                            <IonRadio slot="end" value="ys_asc" />
                          </IonItem>
                          <IonItem>
                            <IonLabel>High to Low</IonLabel>
                            <IonRadio slot="end" value="ys_desc" />
                          </IonItem>
                        </IonRadioGroup>
                      </div>
                    </IonAccordion>

                    {/* WS Sort */}
                    <IonAccordion value="ws">
                      <IonItem slot="header">
                        <IonLabel>WTDS</IonLabel>
                      </IonItem>

                      <div className="ion-padding" slot="content">
                        <IonRadioGroup
                          value={selectedSortOption}
                          onIonChange={(e) => {
                            const value = e.detail.value;
                            setSelectedSortOption(value);

                            if (value === "wtds_asc") {
                              handleAscSort("this_week_amt");
                            } else if (value === "wtds_desc") {
                              handleDesSort("this_week_amt");
                            }
                          }}
                        >
                          <IonItem>
                            <IonLabel>Low to High</IonLabel>
                            <IonRadio slot="end" value="wtds_asc" />
                          </IonItem>
                          <IonItem>
                            <IonLabel>High to Low</IonLabel>
                            <IonRadio slot="end" value="wtds_desc" />
                          </IonItem>
                        </IonRadioGroup>
                      </div>
                    </IonAccordion>

                    {/* MS Sort */}
                    <IonAccordion value="ms">
                      <IonItem slot="header">
                        <IonLabel>MTDS</IonLabel>
                      </IonItem>

                      <div className="ion-padding" slot="content">
                        <IonRadioGroup
                          value={selectedSortOption}
                          onIonChange={(e) => {
                            const value = e.detail.value;
                            setSelectedSortOption(value);

                            if (value === "mtds_asc") {
                              handleAscSort("this_month_amt");
                            } else if (value === "mtds_desc") {
                              handleDesSort("this_month_amt");
                            }
                          }}
                        >
                          <IonItem>
                            <IonLabel>Low to High</IonLabel>
                            <IonRadio slot="end" value="mtds_asc" />
                          </IonItem>
                          <IonItem>
                            <IonLabel>High to Low</IonLabel>
                            <IonRadio slot="end" value="mtds_desc" />
                          </IonItem>
                        </IonRadioGroup>
                      </div>
                    </IonAccordion>
                    {/* WTD growth Sort */}
                    <IonAccordion value="wtd growth">
                      <IonItem slot="header">
                        <IonLabel>WTD Growth</IonLabel>
                      </IonItem>

                      <div className="ion-padding" slot="content">
                        <IonRadioGroup
                          value={selectedSortOption}
                          onIonChange={(e) => {
                            const value = e.detail.value;
                            setSelectedSortOption(value);

                            if (value === "wtdsgr_asc") {
                              handleAscSort("wtd_gr_percent");
                            } else if (value === "wtdsgr_desc") {
                              handleDesSort("wtd_gr_percent");
                            }
                          }}
                        >
                          <IonItem>
                            <IonLabel>Low to High</IonLabel>
                            <IonRadio slot="end" value="wtdsgr_asc" />
                          </IonItem>
                          <IonItem>
                            <IonLabel>High to Low</IonLabel>
                            <IonRadio slot="end" value="wtdsgr_desc" />
                          </IonItem>
                        </IonRadioGroup>
                      </div>
                    </IonAccordion>
                    {/* MTD growth Sort */}
                    <IonAccordion value="mtds growth">
                      <IonItem slot="header">
                        <IonLabel>MTD Growth</IonLabel>
                      </IonItem>

                      <div className="ion-padding" slot="content">
                        <IonRadioGroup
                          value={selectedSortOption}
                          onIonChange={(e) => {
                            const value = e.detail.value;
                            setSelectedSortOption(value);

                            if (value === "mtdsgr_asc") {
                              handleAscSort("mtd_gr_percent");
                            } else if (value === "mtdsgr_desc") {
                              handleDesSort("mtd_gr_percent");
                            }
                          }}
                        >
                          <IonItem>
                            <IonLabel>Low to High</IonLabel>
                            <IonRadio slot="end" value="mtdsgr_asc" />
                          </IonItem>
                          <IonItem>
                            <IonLabel>High to Low</IonLabel>
                            <IonRadio slot="end" value="mtdsgr_desc" />
                          </IonItem>
                        </IonRadioGroup>
                      </div>
                    </IonAccordion>
                  </IonAccordionGroup>
                </IonRadioGroup>
              </div>
            </IonAccordion>

            {viewMode === 'store' && (
              <>
                {/* Store Type Accordion */}
                <IonAccordion value="storetype">
                  <IonItem slot="header"><b>Store Type</b></IonItem>
                  <div className="ion-padding" slot="content">
                    <IonRadioGroup
                      value={storeTypeFilter ?? "all"}
                      onIonChange={(e) => setStoreTypeFilter(e.detail.value === "all" ? null : e.detail.value)}
                    >
                      <IonItem>All Store Types<IonRadio slot="end" value="all" /></IonItem>
                      {masterStoreTypes.map((type) => (
                        <IonItem key={type}>{type}<IonRadio slot="end" value={type} /></IonItem>
                      ))}
                    </IonRadioGroup>
                  </div>
                </IonAccordion>

                {/* Region Accordion - Only show when not in specific region view */}
                {!selectedRegion && (
                  <IonAccordion value="region">
                    <IonItem slot="header"><b>Region</b></IonItem>
                    <div className="ion-padding" slot="content">
                      <IonRadioGroup
                        value={regionCodeFilter ?? "all"}
                        onIonChange={(e) => setRegionCodeFilter(e.detail.value === "all" ? null : e.detail.value)}
                      >
                        <IonItem>All Regions<IonRadio slot="end" value="all" /></IonItem>
                        {masterRegionCodes.map((code) => (
                          <IonItem key={code}>{code}<IonRadio slot="end" value={code} /></IonItem>
                        ))}
                      </IonRadioGroup>
                    </div>
                  </IonAccordion>
                )}
              </>
            )}
          </IonAccordionGroup>
        </IonContent>

        <IonFooter>
          <IonToolbar>
            <IonButtons slot="start">
              <IonButton
                color="medium"
                onClick={() => {
                  setStoreTypeFilter(null);
                  setRegionCodeFilter(null);
                  setSortState("default");
                  handleDSort("default");
                }}
              >
                Clear Filters
              </IonButton>
            </IonButtons>
            <IonButtons slot="end">
              <IonButton
                color="primary"
                onClick={() => setIsMobileFilterDrawerOpen(false)}
              >
                Apply
              </IonButton>
            </IonButtons>
          </IonToolbar>
        </IonFooter>
      </IonModal>

      <IonModal
        isOpen={isSearchModalOpen}
        onDidDismiss={() => setIsSearchModalOpen(false)}
      >
        <IonHeader>
          <IonToolbar>
            <IonTitle>Search Region Name</IonTitle>
            <IonButtons slot="end">
              <IonButton onClick={() => setIsSearchModalOpen(false)}>
                <IonIcon icon={closeOutline} />
              </IonButton>
            </IonButtons>
          </IonToolbar>
        </IonHeader>

        <IonContent className="ion-padding">
          <IonItem>
            <IonIcon icon={searchOutline} slot="start" />
            <IonInput
              type="text"
              value={searchText}
              placeholder="Search Region name..."
              onIonInput={(e) => {
                const value = e.target.value;
                setSearchText(value);
              }}
              clearInput
            />
          </IonItem>

          <IonGrid>
                  <IonRow>
                      <IonCol size="6">
                        <IonButton
                          expand="block"
                          onClick={() => {
                            setIsSearchModalOpen(false);
                            // Trigger your search/filter logic
                          }}
                        >
                          Search
                        </IonButton>
                      </IonCol>

                      <IonCol size="6">
                        <IonButton
                          expand="block"
                          fill="outline"
                          color="medium"
                          onClick={() => {
                            setSearchText(""); // Clear input
                            // Reset your filtered data logic here
                            setIsSearchModalOpen(false); // Optional
                          }}
                        >
                          Clear
                        </IonButton>
                      </IonCol>
                  </IonRow>
          </IonGrid>
          
        </IonContent>
      </IonModal>

    </div>
  );
}
